import { render, staticRenderFns } from "./FlockCard.vue?vue&type=template&id=40b0feaa&scoped=true&"
import script from "./FlockCard.vue?vue&type=script&lang=js&"
export * from "./FlockCard.vue?vue&type=script&lang=js&"
import style0 from "./FlockCard.vue?vue&type=style&index=0&id=40b0feaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b0feaa",
  null
  
)

export default component.exports